import { ParameterType, EndPointDoc } from '../apiref/apireftypes';
import {
    createMessage,
    createMessages,
    createModelInfo,
    createModelInfos,
    createResponse,
    createResponses,
    createTrainingMethod,
    createUsage,
    createGenerateResponse,
    createStreamingChunk,
    createStreamingChunks,
    createTrainPerformance,
    createTrainPerformances,
    createTrainUsage,
    createTrainResponse,
    createTrainStreamingChunk,
    createTrainStreamingChunks,
    createDeleteModelResponse
} from '../types';
import { getResponse } from '../endpoints/getResponse';
import { listModels } from '../endpoints/listModels';
import { newModel } from '../endpoints/newModel';
import { deleteModel } from '../endpoints/deleteModel';
import { train } from '../endpoints/train';

export class ApiRef {
    static types     : Record<string, ParameterType> = {};
    static endpoints : EndPointDoc[] = [];
    static initialized = false;

    static addType(type : ParameterType)
    {
        this.types[type.id] = type;
    }

    static init() : void
    {
        if (this.initialized) {
            return;
        }
        this.initialized = true;

        try {
            this.addType(createMessage());
            this.addType(createMessages());
            this.addType(createModelInfo());
            this.addType(createModelInfos());
            this.addType(createResponse());
            this.addType(createResponses());
            this.addType(createTrainingMethod());
            this.addType(createUsage());
            this.addType(createGenerateResponse());
            this.addType(createStreamingChunk());
            this.addType(createStreamingChunks());
            this.addType(createTrainPerformance());
            this.addType(createTrainPerformances());
            this.addType(createTrainUsage());
            this.addType(createTrainResponse());
            this.addType(createTrainStreamingChunk());
            this.addType(createTrainStreamingChunks());
            this.addType(createDeleteModelResponse());

            this.endpoints.push(getResponse());
            this.endpoints.push(listModels());
            this.endpoints.push(newModel());
            this.endpoints.push(deleteModel());
            this.endpoints.push(train());
        } catch (error) {
            console.error('[ApiRef.init] Initialization failed:', error);
            this.initialized = false;
            throw error;
        }
    }

    static getType(id : string)
    {
        if (!this.initialized) {
            this.init();
        }

        if (this.types[id] === undefined) {
            throw new Error(`Failed to find type: '${id}'`);
        }

        return this.types[id];
    }

    static getAllEndpoints() : EndPointDoc[]
    {
        if (!this.initialized) {
            this.init();
        }

        return this.endpoints;
    }

    static getEndpoint(docurl : string) : EndPointDoc
    {
        if (!this.initialized) {
            this.init();
        }

        const endpoint = this.endpoints.find(endpoint => endpoint.docurl === docurl);
        if (endpoint === undefined) {
            throw new Error(`Failed to find endpoint: '${docurl}'`);
        }

        return endpoint;
    }
}

